import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';
import noop from 'lodash-es/noop';
var MAP_KEY = 'AIzaSyBwKa3oSYmhk_efVFtESIWHK2qwPCRhTw4';
export var MapComponent = function (_a) {
    var center = _a.center, zoom = _a.zoom, fullscreenControl = _a.fullscreenControl;
    var ref = useRef(null);
    useEffect(function () {
        if (!ref.current) {
            return;
        }
        var mapCanvas = ref.current;
        var mapOptions = {
            center: center,
            zoom: zoom,
            fullscreenControl: fullscreenControl
        };
        var map = new google.maps.Map(mapCanvas, mapOptions);
        var marker = new google.maps.Marker({
            position: map.getCenter(),
            map: map
        });
        // Fix SonarQube error about useless object instantiation
        noop(marker);
    }, [ref, center, fullscreenControl, zoom]);
    return (_jsx("div", { style: {
            height: '30vh',
            width: '100%',
            minHeight: '100%',
            maxHeight: 'none',
            borderRadius: '10px'
        }, ref: ref, id: "map", "data-type": "map", "data-reason": "map", "data-object": "map", "data-analytics": "clicktrackingevent", className: "ensightencustomevent" }));
};
var GoogleMap = function (_a) {
    var center = _a.center, _b = _a.zoom, zoom = _b === void 0 ? 16 : _b, _c = _a.fullscreenControl, fullscreenControl = _c === void 0 ? false : _c;
    return (_jsx(Wrapper, { apiKey: MAP_KEY, children: Number.isNaN(center.lat) ? null : (_jsx(MapComponent, { center: center, zoom: zoom, fullscreenControl: fullscreenControl })) }));
};
export default GoogleMap;
//# sourceMappingURL=index.js.map